import * as React from 'react';

import { ComposerRecipients_composerRecipients_recipients_ComposerRecipientListEntity } from 'chat_v2/components/SplitComposer/queries/__generated__/ComposerRecipients';

export type ComposerState = {
  recipients: { [uuid: string]: ComposerRecipients_composerRecipients_recipients_ComposerRecipientListEntity };
  filters: { [recipientUuid: string]: { [filterType: string]: string[] } };
}

export type ComposerDispatchAction = 
  | { type: 'addRecipient', entity: ComposerRecipients_composerRecipients_recipients_ComposerRecipientListEntity }
  | { type: 'removeRecipient', uuid: string }
  | { type: 'addFilter', recipientUuid: string, filterType: string, filterValue: string }
  | { type: 'removeFilter', recipientUuid: string, filterType: string, filterValue: string };

export type ComposerDispatch = (action: ComposerDispatchAction) => void;

const defaultState: ComposerState = {
  recipients: {},
  filters: {},
};

export const ComposerStateContext = React.createContext<ComposerState>(defaultState);
export const ComposerDispatchContext = React.createContext<ComposerDispatch>(() => {});

function composerReducer(state: ComposerState, action: ComposerDispatchAction) {
  switch (action.type) {
    case 'addRecipient': {
      const recipients = state.recipients;
      recipients[action.entity.recipient.uuid] = action.entity;
      return { ...state, recipients };
    } 
    case 'removeRecipient': {
      const recipients = state.recipients;
      delete recipients[action.uuid];
      return { ...state, recipients };
    }
    case 'addFilter': {
      const filters = state.filters;

      if (!filters[action.recipientUuid]) {
        filters[action.recipientUuid] = {};
      }
      
      if (!filters[action.recipientUuid][action.filterType]) {
        filters[action.recipientUuid][action.filterType] = [];
      }
      
      filters[action.recipientUuid][action.filterType].push(action.filterValue);
      
      return { ...state, filters };
    }
    case 'removeFilter': {
      const filters = state.filters;
      const recipientFilters = filters[action.recipientUuid][action.filterType];
      recipientFilters.splice(recipientFilters.indexOf(action.filterValue), 1);
      return { ...state, filters };
    }
    default: 
      return state;
  }
}

export function ComposerContextProvider({ children }: { children: React.ReactNode }) {
  const [state, dispatch] = React.useReducer(composerReducer, defaultState);

  return (
    <ComposerStateContext.Provider value={state}>
      <ComposerDispatchContext.Provider value={dispatch}>
        {children}
      </ComposerDispatchContext.Provider>
    </ComposerStateContext.Provider>
  )
}
